module.exports = __webpack_public_path__ + "static/media/btn-icn.5a591a08.svg";